import { render, staticRenderFns } from "./AddonsResume.vue?vue&type=template&id=a36dc476&"
import script from "./AddonsResume.vue?vue&type=script&lang=js&"
export * from "./AddonsResume.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports